import axios from 'axios'
import _ from "lodash";
import {updateGridRowData} from "../../grid/update";
import {handleRemoteSelectbox} from "./selectbox";
import {reloadGridDetailContent} from "../../grid/detail";

window.activeTooltip = null;
window.activeTooltipClosable = false;

kendo.ui.Popup.fn.close = function (close) {
	return function (skipeffects) {
		try {
			close.call(this, skipeffects);
		} catch (err) {
			// suppress error if its the right type
			if (!(err instanceof PreventTooltipHideException)) {
				throw err;
			}
		}
	}
}(kendo.ui.Popup.fn.close);

$(document).keydown(function (e) {
	if (window.activeTooltip && e.key === 'Escape') {
		closeTooltip(window.activeTooltip);
	}
});

export function initializeXEditable(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[x-editable-form] input, [x-editable-form] select, [x-editable-form] textarea, [x-editable-item]');
	} else {
		var $cont = $(selector + ' [x-editable-form] input, [x-editable-form] select, [x-editable-form] textarea, [x-editable-item]');
	}

	$cont.each(function (idx) {
		let $el = $(this);
    let $form = $el.closest('form[x-editable-form]');
    let isReadOnly = typeof $form.attr('readonly') !== 'undefined';
    console.log(isReadOnly);

		if ($el.data('role') === 'datepicker' || $el.data('role') === 'maskedtextbox') {
			// console.log($el);

			if (typeof $el.data("kendoDatePicker") !== 'undefined') {
				$el.data("kendoDatePicker").destroy();
				$el.attr('x-editable-item', 'datepicker').removeClass('k-input').attr('style', null);
			}

			if (typeof $el.data("kendoMaskedTextBox") !== 'undefined') {
				$el.data("kendoMaskedTextBox").destroy();
				$el.removeClass('k-input').attr('style', null);
			}

			$el.closest('.form-group').find('.k-select').remove();
			$el.closest('.form-group').find('.k-button').remove();
			if ($el.parent().is('span')) {
				$el.unwrap();
			}
		}

		var type = null;
		if ($el.is("textarea")) {
			type = 'textarea';
		} else if (typeof $el.attr('remote-selectbox') !== 'undefined') {
			type = 'remote-select';
		} else if ($el.is("select")) {
			type = "select";
		} else if (typeof $el.attr("x-editable-item") !== 'undefined') {
			type = $el.attr("x-editable-item");
		} else if ($el.is("span")) {
			type = "span";
		} else {
			type = $el.attr('type');
		}

		// console.log(type);

		if (
			typeof $el.attr('data-processed') !== 'undefined'
			|| typeof $el.attr('x-editable-skip') !== 'undefined'
			|| typeof $el.attr('wysiwyg') !== 'undefined'
			|| typeof $el.closest('.k-toolbar').get(0) !== 'undefined'
		) {
			return;
		}

		let optionDataSource = [];
		var replaceBySpan = true;
		var height = '36px';
		switch (type) {
			case 'text':
			case 'number':
			case 'password':
			case 'email':
				var $templateContent = $("#x-editable-text");
				break;

			case 'textarea':
				var $templateContent = $("#x-editable-textarea");
				var height = '120px';
				break;

			case 'datepicker':
				var $templateContent = $("#x-editable-datepicker");
				break;

			case 'colorpicker':
				var $templateContent = $("#x-editable-colorpicker");
				break;

			case 'datetimepicker':
				var $templateContent = $("#x-editable-datetimepicker");
				break;

			case 'remote-select':
				var $templateContent = $("#x-editable-remote-select");
				break;

			case 'select':
				var $templateContent = $("#x-editable-select");
				$el.find('option').each(function (idx) {
					let $option = $(this);
					optionDataSource.push({
						value: $option.val(),
						text: $option.text()
					});

					if ($option.is(':selected')) {
						$el.data('default-value', $option.val());
						$el.data('value', $option.text());
					}
				});
				break;

			case 'checklist':
				var $templateContent = $("#x-editable-checklist");
				var height = '120px';
				break;

			case 'span':
				replaceBySpan = false;
				break;

			case 'checkbox':
				$el.attr('data-name', $el.attr('name')).on('change', function (event) {

					// checkbox list
					if ($el.attr('name').match(/\[\]$/)) {
						let cboxListValue = [];
						$('[name="' + $el.attr('name') + '"]:checked').each(function(idx) {
							let $cboxItem = $(this)
							cboxListValue.push($cboxItem.val())
						})

						sendPostRequest($(this), {
							value: cboxListValue
						});

						return;
					}

					sendPostRequest($(this), {
						value: $(this).is(':checked')
					});
				});
				return;

			default:
				replaceBySpan = false;
				return;
		}

		var emptyText = 'Nastavit';
		if (type === 'colorpicker') {
			emptyText = '#000000';
		}

		if (replaceBySpan) {
			$el.hide().attr('data-processed', 'true');
			var template = kendo.template($templateContent.html());
		} else {
			var conf = $el.data('conf');
			var jsonParse = {}
			if (typeof conf !== 'object') {
				try {
					jsonParse = JSON.parse(conf.trim().replace(/\t/g, ' ').replace(/\r?\n|\r/g, '#NL#'));
				} catch (err) {
					console.log(err.message)
					console.log(conf.trim().replace(/\r?\n|\r/g, '#NL#'))
				}
				$el.data('conf', jsonParse);
				conf = jsonParse;
				if (typeof conf.emptyText !== 'undefined') {
					emptyText = conf.emptyText;
				}
			}
		}

		let data = {
			xvalue: $el.val() === '' ? emptyText : $el.val()
		}

		if (typeof $el.data('value') !== 'undefined') {
			data.xvalue = $el.data('value')
		}

		data.xvalue = data.xvalue === null || data.xvalue === '' ? emptyText : data.xvalue;

		$el.attr('data-value', data.xvalue);

		if (replaceBySpan) {
			var $span = $('<span>').html(data.xvalue).attr('data-value', data.xvalue).attr('data-name', $el.attr('name')).attr('data-conf', $el.data('conf'));
			$span.attr('data-source', $el.attr('data-source'));
			$span.attr('data-empty', $el.attr('data-empty'));
			$span.attr('data-url', $el.attr('data-url'));
			$span.attr('no-grid', $el.attr('no-grid'));
			$span.data('default-value', $el.data('default-value'));
			$span.data('after', $el.data('after'));
			$span.data('null-value', emptyText);
			$span.data('source-elem', $el);
			$span.attr('data-search-fields', $el.data('search-fields'));
			$span.attr('data-server-filtering', $el.data('server-filtering'));
			$span.attr('data-source', $el.data('source'));
			$span.attr('data-readonly', $el.prop('readonly'));

      if (isReadOnly) {
        $span.attr('data-readonly', true);
      }

			if (optionDataSource.length > 0) {
				$span.data('source', optionDataSource);
			}

			$el.after($span);
		} else {
			var $span = $el;
		}

		$span.attr('x-editable', type);

		let maxWidth = $(window).width() * 0.95;

		var defWidth = '180';
		if (data.xvalue.length >= 20 || type === 'textarea' || type === 'checklist') {
			defWidth = '450';
		} else if (data.xvalue.length > 6 && data.xvalue.length < 20 || type === 'select' || type === 'multiselect') {
			defWidth = '300';
		}

		defWidth = (defWidth > maxWidth) ? maxWidth : defWidth;

		createKendoTooltip($span, template, data, defWidth + 'px', height);
	});
}

function createKendoTooltip($el, template, data, defWidth, height) {
  if ($el.data('readonly') === true) {
    return;
  }

	$el.kendoTooltip({
		showOn: "click",
		autoHide: true,
		content: template(data),
		width: defWidth,
		height: height,
		show: function (event) {
			let popup = this;

			if (window.activeTooltip) {
				closeTooltip(window.activeTooltip);
			}

			window.activeTooltip = this;

			preparePopup($el);

			$('.x-editable-wrapper input, .x-editable-wrapper textarea').focus().select();
		},
		hide: function (e) {
			if (!window.activeTooltipClosable) {
				throw new PreventTooltipHideException();
			}
		},
	});
}

function saveNewValue($el, newValue) {
	if ($el.data('value') !== newValue.value) {
		sendPostRequest($el, newValue);
	}
}

function getDestUrl($el) {
	let url = $el.data('url');

	if (typeof url === 'undefined') {
		url = $el.closest('[data-xurl]').data('xurl');
	}

	if (typeof url === 'undefined') {
		url = $el.closest('form').attr('action');
	}

	return url;
}

function prepareFormData($el, newValue) {
	var data = new FormData();
	let configuration = $el.data('conf');

	if (typeof configuration !== 'undefined' && typeof configuration.params !== 'undefined') {
		_.forIn(configuration.params, function (val, key) {
			data.append(key, val);
		})
	} else {
		data.append('_do', 'changeField')
	}

	data.append('name', $el.data('name'))
	if (Array.isArray(newValue.value)) {
		_.forEach(newValue.value, function (val) {
			data.append('value[]', val)
		})
	} else {
		data.append('value', newValue.value)
	}

	return data;
}

function setReturnedValue(response, newValue, $el) {
	if (response.data.newValue != newValue.value
		&& $el.attr('x-editable') != 'datepicker'
		&& $el.attr('x-editable') != 'datetimepicker'
		&& $el.attr('x-editable') != 'select'
		&& $el.attr('x-editable') != 'checklist'
	) {
		if (typeof response.data.newValue !== 'undefined') {
			if (response.data.newValue !== null) {
				if(typeof response.data.newValue === 'string') {
					$el.html(response.data.newValue.replace(/\n/g, '<br />'));
				}
			} else {
				$el.html('Nastavit');
			}

			$el.data('value', response.data.newValue);
		}
	}
}

function sendPostRequest($el, newValue) {
	let url = getDestUrl($el);

	if (typeof url === 'undefined') {
		staticNotification.error('Chyba v nastavení, kontaktujte správce.');
		return false;
	}

	let $originalField = $el.data('source-elem');
	if (typeof $originalField !== 'undefined') {
		$originalField.val(newValue.value);
	}

	let data = prepareFormData($el, newValue);

	let $cont = $el.closest('[x-editable-form]');
	let refreshUrl = $cont.data('refresh-url');

	axios
		.post(url, data)
		.then(response => {
			if (!$el.is('[type=checkbox]')) {
				if (newValue.text === '') {
					$el.html($el.data('null-value'));
				} else {
					$el.html(newValue.text.replace(/\n/g, '<br />'));
				}

				if (Array.isArray(newValue.value)) {
					$el.data('value', newValue.value.join(','));
				} else {
					$el.data('value', newValue.value);
				}
			}

			if (response.status === 200 && response.data.result) {
				staticNotification.success('Data úspěšně změněna.');
				setReturnedValue(response, newValue, $el);

				if (typeof $el.attr('no-grid') === 'undefined' && response.data.model !== undefined) {
					updateGridRowData(response.data.model, false)
				}

				if (typeof refreshUrl !== 'undefined') {
					najaGlobal.makeRequest('GET', refreshUrl);
				}

				if ($el.data('after') === 'reload-detail') {
					reloadGridDetailContent();
				}

			} else {
				staticNotification.error(response.data.errorMessage);
			}
		});

}

function preparePopup($el) {
	let conf = $el.data('conf');

	let $wrapper = $el.data('kendoTooltip').popup.wrapper;

	let left = parseInt($wrapper.css('left').replace(/px/, ''));
	let width = parseInt($wrapper.css('width').replace(/px/, ''));
	$wrapper.css('width', '351px');
	$wrapper.find('> div').css('width', '350px');
	left = left - (351 - width);
  left = Math.max(left, 10);

	var leftMargin = left + 351;
	if (leftMargin > $(document).width() * 0.95) {
		$wrapper.css('left', 'auto').css('right', '15px');
	} else {
		$wrapper.css('left', left + 'px');
	}

	$wrapper.find('div.k-callout').css('left', '50%');

	$wrapper.find('.button--cancel').off('click').on('click', function (event) {
		event.preventDefault();
		closeTooltip(window.activeTooltip);
	});

	$wrapper.find('.button--save').off('click').on('click', function (event) {
		event.preventDefault();
		saveNewValue($el, getNewValue($el));
		closeTooltip(window.activeTooltip);
	});

	let source = $el.data('source');

	switch ($el.attr('x-editable')) {
		case 'datepicker':
			kendo.init($wrapper.find('.x-editable-wrapper'));
			$wrapper.find('[data-role="datepicker"]').data("kendoDatePicker").open();
			break;

		case 'colorpicker':
			kendo.init($wrapper.find('.x-editable-wrapper'));
			break;

		case 'remote-select':
			let $sb = $wrapper.find('.x-editable-wrapper select');
			$sb.attr('data-search-fields', $el.data('search-fields'));
			$sb.attr('data-server-filtering', $el.data('server-filtering'));
			$sb.attr('data-source', $el.data('source'));
			$sb.attr('data-value', $el.data('value'));
			$sb.attr('data-empty', $el.data('empty'));
			$sb.attr('data-default-value', $el.data('default-value'));
			$sb.attr('data-default-open', true);
			handleRemoteSelectbox($wrapper.find('.x-editable-wrapper'));
			break;

		case 'datetimepicker':
			kendo.init($wrapper.find('.x-editable-wrapper'));
			$wrapper.find('[data-role="datetimepicker"]').data("kendoDateTimePicker").open();
			break;

		case 'text':
		case 'textarea':
			kendo.init($wrapper.find('.x-editable-wrapper'));
			$wrapper.find('.x-editable-wrapper input[type="text"]').off('keypress').on('keypress', function (event) {
				if (event.which == 13) {
					$wrapper.find('.x-editable-wrapper .button--save').trigger('click');
				}
			})
			break;

		case 'checklist':
		case 'select':
			let valueField = 'value';
			let textField = 'text';

			if (Array.isArray(source)) {
				var dataSource = new kendo.data.DataSource({
					data: source,
				});
			} else {
				let ref = source.match(/\?fields=([a-zA-Z,]+)/);

				if (ref[1]) {
					[valueField, textField] = ref[1].split(',');
				}

				var dataSource = new kendo.data.DataSource({
					transport: {
						read: {
							url: source,
							dataType: "json"
						},
						cache: true
					}
				});
			}

			if ($el.attr('x-editable') === 'select') {
				let definition = {
					filter: "contains",
					dataTextField: textField,
					dataValueField: valueField,
					dataSource: dataSource,
					value: $el.data('default-value'),
				};

				if ($el.attr('data-empty') === 'true') {
					definition.optionLabel = '---';
				}

				$wrapper.find('[data-role="dropdownlist"]').kendoDropDownList(definition);
			} else {
				$wrapper.find('#x-editable-multiselect').kendoMultiSelect({
					filter: "contains",
					dataTextField: "text",
					dataValueField: "value",
					dataSource: dataSource,
					value: $el.data('value').split(/,/),
				});
			}
			break;

	}

}

function getNewValue($el) {
	let $wrapper = $el.data('kendoTooltip').popup.wrapper;
	var newValue = null;
	var newDisplayedValue = null;

	switch ($el.attr('x-editable')) {
		case 'colorpicker':
			newValue = newDisplayedValue = $wrapper.find('[data-role="colorpicker"]').val();
			break;

		case 'datepicker':
			newValue = newDisplayedValue = $wrapper.find('[data-role="datepicker"]').val();
			break;

		case 'datetimepicker':
			newValue = newDisplayedValue = $wrapper.find('[data-role="datetimepicker"]').val();
			break;

		case 'password':
		case 'text':
		case 'email':
		case 'number':
			newValue = newDisplayedValue = $wrapper.find('input[type="text"]').val();
			break;

		case 'textarea':
			newValue = newDisplayedValue = $wrapper.find('textarea').val();
			break;

		case 'select':
		case 'remote-select':
			newValue = $wrapper.find('[data-role="dropdownlist"]').data("kendoDropDownList").value();
			newDisplayedValue = $wrapper.find('[data-role="dropdownlist"]').data("kendoDropDownList").text();
			break;

		case 'checklist':
			newValue = newDisplayedValue = $wrapper.find('[data-role="multiselect"]').data("kendoMultiSelect").value();
			var list = [];
			_.forEach($wrapper.find('[data-role="multiselect"]').data("kendoMultiSelect").dataItems(), function (value) {
				if (typeof value.html !== 'undefined') {
					list.push(value.html);
				} else {
					list.push(value.text);
				}
			});

			newDisplayedValue = list.join(', ');
			break;
	}

	return {
		value: newValue,
		text: newDisplayedValue
	}
}

function closeTooltip(popup) {
	window.activeTooltipClosable = true;

	if (popup) {
		let multiSelect = $("#x-editable-multiselect").data("kendoMultiSelect");
		if (typeof multiSelect !== 'undefined') {
			$("#x-editable-multiselect").data("kendoMultiSelect").destroy();
		}
		$('.k-multiselect-wrap').detach();
		popup.hide();
	}

	window.activeTooltipClosable = false;
	window.activeTooltip = null;
}

export function PreventTooltipHideException() {
}

window.PreventTooltipHideException = PreventTooltipHideException;
